<template lang="pug">
  #chapter5
    // Navbar
    BlogsNavBar
    
    // Intro
    #ch5sections.container-fluid
      .row.d-flex.justify-content-center.align-items-center
        .col-11.col-md-9.col-lg-8(v-html="blogData.content ? blogData.content.rendered : ''")

    Footer
</template>

<script>
import BlogsNavBar from "@/components/BlogsNavBar.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "chapter5",
  components: {
    BlogsNavBar,
    Footer
  },
  data() {
    return {
      blogData: {},
    };
  },
  async mounted() {
    this.blogData = (await this.$store.dispatch("getWomenCallsBlog")).data[0];
    //console.log(this.blogData);
  }
};
</script>

<style lang="scss">
#chapter5 {
  #ch5sections {
    margin-bottom: 2rem;
    img {
      max-height: 100vh;
      max-width: 100%;
      display: block;
      margin: auto;
    }
    .chapter-logo {
      width: 220px;
    }
    .light-title {
      font-family: Oswald;
      font-size: 50px;
      font-weight: 300;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.1;
      letter-spacing: normal;
      text-align: center;
      text-transform: uppercase;
    }
    .title {
      font-family: Oswald;
      font-size: 63px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.1;
      letter-spacing: normal;
      text-align: center;
      text-transform: uppercase;
      margin-bottom: 1.5rem;
      .top {
        color: #0a1d59;
      }
      .bottom {
        color: #34afb2;
      }
    }
    .author {
      font-family: "Inria Sans", sans-serif;
      font-size: 1rem;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #0a1d59;
      margin-bottom: 2rem;
    }
    .intro-illustration {
      width: 80%;
      max-width: 800px;
    }
    .copyright {
      font-family: "Inria Sans", sans-serif;
      font-size: 16px !important;
      font-weight: normal;
      font-stretch: normal;
      font-style: italic;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #0a1d59;
    }
    .intro {
      font-family: "Inria Sans", sans-serif;
      font-size: 0.9rem;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.58;
      letter-spacing: normal;
      color: #0a1d59;
    }
    .subtitle {
      font-family: Oswald;
      font-size: 30px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.8;
      letter-spacing: normal;
      color: #0a1d59;
      background-color: #f7b3aa;
      display: inline-table;
      padding: 12px 40px 12px 40px;
      margin-top: 1.5rem;
      line-height: 1.3;
    }
    .text {
      font-family: "Inria Sans", sans-serif;
      font-size: 0.9rem;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.58;
      letter-spacing: normal;
      color: #0a1d59;
    }
    .quote {
      font-weight: 700;
      padding-left: 5%;
    }
    .footnote {
      padding-left: 5%;
      .number {
        font-size: 18px;
      }
      .text {
        font-size: 18px;
      }
    }
  }
}
@media (max-width: 768px) {
  #chapter5 {
    #ch5sections {
      .title, .light-title {
        font-size: 3.2rem;
      }
      .intro {
        font-size: 1.1rem;
      }
      .subtitle {
        line-height: 1.5;
        font-size: 20px;
      }
      .text {
        font-size: 1.1rem;
      }
    }
  }
}
@media (max-width: 420px) {
  #chapter5 {
    #ch5sections {
      .intro {
        font-size: 1.1rem;
      }
      .subtitle {
        font-size: 20px;
      }
      .text {
        font-size: 1.1rem;
      }
    }
  }
}
</style>
